module.exports = __webpack_public_path__ + "img/electric_use.3c973865.svg";